import { useState } from 'react';

import { Gate } from '../../../global/contexts/auth/auth';
import { IconUpload } from '../../../common/icons';
import SgCows from './cows';
import UploadModal from '../forms/upload-modal';

import '../styles/sg.css';

// Software Ganadero · contenedor del navegador de vacas físicas (admin-sg.md). Título
// + acción "Subir backup" (gated sg:write, abre el modal de D-002) + la lista de vacas.
// SIN tabs de Backups: el historial de ingestas es operación interna, no del usuario
// final. La ruta ya está gateada a sg:read en app.jsx.
export default function SgPanel() {
    const [uploadOpen, setUploadOpen] = useState(false);
    return (
        <div className="sg-panel">
            <header className="sg-panel__header">
                <div className="sg-panel__heading">
                    <h1 className="sg-panel__title">Software Ganadero</h1>
                    <p className="sg-panel__subtitle">Vacas conciliadas con sus fichas de Software Ganadero.</p>
                </div>
                <Gate domain="sg" action="write">
                    <button type="button" className="sg-panel__upload" onClick={() => setUploadOpen(true)}>
                        <IconUpload /> <span>Subir backup</span>
                    </button>
                </Gate>
            </header>

            <SgCows />

            {uploadOpen && <UploadModal onClose={() => setUploadOpen(false)} />}
        </div>
    );
}
